import JobsTableLayout from "@/pages/_layouts/jobs/JobsTableLayout";

export default function AllJobsPage() {
  return (
    <JobsTableLayout
      tableDescription="View and manage all jobs posted for facilities on the PGA job board"
      columnHeaders={{
        title: true,
        facility: true,
        serviceLevel: true,
        totalCompensation: false,
        employer: true,
        owner: false,
        postedOn: true,
        submissionDeadline: true,
        applicantCount: true,
        postingStage: true,
        jobStatus: true,
        section: true
      }}
      filters={{
        postingStage: true,
        jobStatus: true,
        serviceLevel: true,
        postedDateRange: true,
        section: true,
        owner: false
      }}
      defaultValues={{
        stage: []
      }}
      defaultSort={[{ id: "goLiveTime", desc: true }]}
    />
  );
}
